import { handleActions, combineActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = null

export default handleActions(
  {
    [rawActions.setEmailRecipientsDialogState](state, action) {
      return action.payload
    },
    [combineActions(rawActions.exportAsPdfRequest, rawActions.openExportImagesDialog)](state, action) {
      return null
    },
    [rawActions.resetGalleryState](state, action) {
      return defaultState
    },
  },
  defaultState
)
